import React, { useEffect, useState } from "react";
import { API } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import { toast } from "sonner";

export default function ReferralCard() {
  const { t } = useI18n();
  const [data, setData] = useState(null);
  const [recipient, setRecipient] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    fetch(`${API}/me/referral`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then(setData)
      .catch(() => setData(null));
  }, []);

  if (!data) return null;

  const sendInvite = async () => {
    const email = recipient.trim().toLowerCase();
    if (!email || !email.includes("@")) {
      toast.error("Email invalide");
      return;
    }
    setSending(true);
    try {
      const r = await fetch(`${API}/me/referral/invite`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          recipient_email: email,
          origin_url: window.location.origin,
        }),
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.detail || "Erreur d'envoi");
      }
      toast.success(`Invitation envoyée à ${email}`);
      setRecipient("");
    } catch (e) {
      toast.error(String(e.message || e));
    } finally {
      setSending(false);
    }
  };

  return (
    <section
      data-testid="referral-card"
      className="mt-10 bg-white border-2 border-[#0A0A0A] shadow-brutal p-6"
    >
      <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-4 mb-4">
        <div>
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#FF3B30] font-bold">
            // GROWTH
          </p>
          <h3 className="font-display text-xl uppercase mt-1">
            {t("referral_title")}
          </h3>
          <p className="font-mono-corp text-xs text-[#4B4B4B] mt-1 max-w-xl">
            {data.eligible_to_refer ? t("referral_subtitle") : t("referral_locked")}
          </p>
        </div>
        <div className="flex gap-3 text-xs font-bold uppercase">
          <div className="border-2 border-[#0A0A0A] px-3 py-2 bg-[#F4F4F0]">
            <div className="text-[10px] text-[#4B4B4B]">{t("referral_invited")}</div>
            <div data-testid="ref-invited-count" className="font-display text-xl">
              {data.referrals_count}
            </div>
          </div>
          <div className="border-2 border-[#0A0A0A] px-3 py-2 bg-[#FFCC00]">
            <div className="text-[10px]">{t("referral_rewarded")}</div>
            <div data-testid="ref-rewarded-count" className="font-display text-xl">
              {data.referrals_rewarded_count}/{data.cap}
            </div>
          </div>
        </div>
      </div>

      {data.eligible_to_refer && (
        <div className="flex flex-col sm:flex-row gap-3 items-stretch">
          <input
            data-testid="referral-recipient-input"
            type="email"
            value={recipient}
            onChange={(e) => setRecipient(e.target.value)}
            placeholder="email.du.collegue@entreprise.com"
            className="flex-grow bg-[#F4F4F0] border-2 border-[#0A0A0A] px-3 py-2 font-mono-corp text-sm focus:outline-none focus:bg-[#FFCC00]"
          />
          <button
            data-testid="referral-send-btn"
            onClick={sendInvite}
            disabled={sending}
            className="bg-[#FF3B30] text-white border-2 border-[#0A0A0A] font-display text-sm uppercase tracking-widest px-6 py-2 hover:bg-[#0A0A0A] transition-all disabled:opacity-50"
          >
            {sending ? "..." : "ENVOYER L'INVITATION →"}
          </button>
        </div>
      )}
    </section>
  );
}
